import { FC, useContext, useEffect } from 'react';

import { Form as FormAntd } from 'antd';

import {
  ColSize,
  InputForm,
  RowSize,
  SelectForm,
} from '../../../../../../../../../../../shared/components';
import { ContactForm, SectionQuotation } from '../../../../../../../shared';

import { StepFourFormContext } from '../../../../contexts/StepFourForm';

import { ValidateForm } from '../../../../../../../../../../../shared/utils';
import { INSPECTION_TYPES } from '../../../../../../interfaces';

interface InspectionProps {
  tabKey: number;
}

export const Inspection: FC<InspectionProps> = ({ tabKey }) => {
  const validateForm = new ValidateForm();

  const { tabsSectionForm, inspectionList, isLoadingInspectionList } =
    useContext(StepFourFormContext);

  const typeInspection: string = FormAntd.useWatch(
    `typeInspection-tab-${tabKey}`,
    tabsSectionForm
  );

  const isTecnored = typeInspection === INSPECTION_TYPES.TECNORED_CENTER

  useEffect(() => {
    tabsSectionForm?.resetFields([`tecnoredCenter-tab-${tabKey}`]);
    /* eslint-disable-next-line */
  }, [typeInspection]);

  return (
    <SectionQuotation level='h3' title='Inspección' hasCard={false}>
      <RowSize>
        <ColSize size={25}>
          <SelectForm
            formProps={{
              label: 'Tipo Inspección:',
              name: `typeInspection-tab-${tabKey}`,
              rules: validateForm.generateRules({
                label: 'tipo de inspección',
                rules: ['required'],
              })
            }}
            selectProps={{
              options: inspectionList,
              loading: isLoadingInspectionList,
            }}
          />
        </ColSize>
        {typeInspection === INSPECTION_TYPES.TECNORED_CENTER && (
          <ColSize size={25}>
            <InputForm
              formProps={{
                label: 'Centro Tecnored:',
                name: `tecnoredCenter-tab-${tabKey}`,
                rules:
                  typeInspection === INSPECTION_TYPES.TECNORED_CENTER
                    ? validateForm.generateRules({
                        label: 'centro tecnored',
                        rules: ['required'],
                      })
                    : undefined,
              }}
            />
          </ColSize>
        )}
      </RowSize>
   
      <RowSize>
        <ContactForm
          componentId={String(tabKey)}
          showFullName={isTecnored}
          requiredFullName={isTecnored}
          showPhone={isTecnored}
          requiredPhone={isTecnored}
          showEmail={isTecnored}
          requiredEmail={isTecnored}
          showAvailability={isTecnored}
          requiredAvailability={isTecnored}
          showComments={isTecnored}
          requiredComments={isTecnored}
        />
      </RowSize>
    </SectionQuotation>
  );
};
